import React from 'react';
import { Typography, TypographyProps } from '@material-ui/core';
import { timeStringAs12Hr } from '@utilities/dateUtilities';

interface DisplaySimpleTimeFrameProps extends TypographyProps {
	startTime: string; // 24-hour format string
	endTime: string; // 24-hour format string
}

// Should be used when the times do not need to be converted using a timezone
const DisplaySimpleTimeFrame: React.FC<DisplaySimpleTimeFrameProps> = ({ startTime, endTime, ...typographyProps }) => {
	return (
		<Typography {...typographyProps}>
			{timeStringAs12Hr(startTime)} - {timeStringAs12Hr(endTime)}
		</Typography>
	);
};

export default DisplaySimpleTimeFrame;
